import { jsx as m } from "react/jsx-runtime";
import { withManagedProps as f } from "@made-people/managed-props";
import { z as l } from "zod";
import { withZod as v } from "@made-people/react-prop-guard";
import { overlayBlueprint as p } from "./index-blueprint.es.js";
import { useId as y, useState as u, useEffect as O } from "react";
import { createEventEmitter as I } from "@made-people/grease-event-emitter";
import { AnimatePresence as h, motion as E } from "motion/react";
import "@made-people/blueprint";
const n = I();
function x(a) {
  const s = y(), o = a ?? s, [i, e] = u(void 0);
  O(() => {
    const r = (t) => e(t.overlayId === o), c = (t) => {
      ((t == null ? void 0 : t.overlayId) === void 0 || t.overlayId === o) && e(!1);
    };
    return n.on("open", r), n.on("close", c), () => {
      n.off("open", r), n.off("close", c);
    };
  }, []);
  function d(r) {
    e(r), n.emit(r ? "opened" : "closed", { overlayId: o });
  }
  return {
    /**
     * Use this to determine the open state of your overlay
     */
    isOpen: i,
    /**
     * Call this function when the "open" state of your overlay changes
     */
    onChange: d,
    /**
     * ID representing your unique overlay
     */
    overlayId: o
  };
}
const C = l.object({
  variants: l.custom().optional(),
  zIndex: l.number().optional()
}), S = "globalID", D = f(
  "Overlay",
  v(C, ({ variants: a }) => {
    const s = p.styles(a), o = x(S), { isOpen: i } = o, e = () => {
      n.emit("close", {});
    };
    return /* @__PURE__ */ m(h, { children: i ? /* @__PURE__ */ m(
      E.div,
      {
        className: s.overlay,
        initial: { opacity: 0 },
        onClick: () => e(),
        animate: {
          opacity: 100,
          transition: {
            duration: 0.15,
            ease: "easeOut"
          }
        },
        exit: {
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: "easeOut"
          }
        }
      }
    ) : null });
  })
);
export {
  S as GLOBAL_OVERLAY_ID,
  D as Overlay,
  n as overlayEventEmitter,
  C as overlaySchema,
  x as useOverlayState
};
//# sourceMappingURL=index.es.js.map
